import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'selectedContainer' ]

  changeSet(e) {
    const target = e.currentTarget
    if (!target) return
    const option = document.querySelector(`#plans option[value="${target.value.replace(/["\\]/g, '\\$&')}"]`)
    if (!option) return
    const li = document.createElement('li')
    li.classList.add('c-selected-items__item')
    li.innerHTML = this.template(target.value, option.dataset.plan_id)
    this.container.append(li)
    option.remove()
    target.value = ''
  }

  deleteSet(e) {
    const item = e.currentTarget.closest('.c-selected-items__item')
    if (!item) return
    const selected = item.querySelector('.selected_plans')
    if (!selected) return
    const option = document.createElement('option')
    option.setAttribute('data-plan_id', selected.value)
    option.setAttribute('value', selected.dataset.name)
    document.querySelector('#plans').append(option)
    item.remove()
  }

  template(name, planId) {
    return `<span class="plan-name"> ${this.escapeHtml(name)}</span>
<i class="fa fa-times" data-action="click->admin--special-report#deleteSet"></i>
<input type="hidden" value="${planId}" name="special_report[plan_ids][]" data-name="${this.escapeHtml(name)}" class="selected_plans" />`
  }

  escapeHtml(str) {
    return str
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
  }

  get container() {
    return this.selectedContainerTarget
  }
}
